export default {"src":"/org/_next/static/media/play-store-small.0744a11a.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};